module.exports = __webpack_public_path__ + "img/solution-tripleElectricHIL-architecture-pic.fe29cf71.png";